export function isProductionMode<T = any>(production: any, otherMode: any): T {
  const _env = { ...process?.env, ...env };
  return (_env?.mode || process.env.NODE_ENV) === 'production' ? production : otherMode;
}
